/**
 * MinelabRttrLoadingFallback
 *
 * Brand-isolated loading state shown while:
 *   1. HubPageRouter is resolving `useGetHub(slug)` (~100-500ms cold)
 *   2. The React.lazy chunk for MinelabRttrHub is downloading (~200-1000ms cold)
 *
 * Styles live in `web/src/style/_minelab-rttr-loading.scss`, imported from
 * `index.scss` (the global bundle), so they are available at React-mount-time
 * without depending on the MinelabRttrHub.scss lazy chunk.
 *
 * Image path `/images/minelab-rttr/minelabs-logo.png` is self-hosted (asset
 * migration 2026-05-12), so no external fetch required.
 */

import React from "react";

export const MinelabRttrLoadingFallback: React.FC = () => {
    return (
        <div className="ml-rttr-loading-shell" role="status" aria-label="Loading Race to the Realm">
            <img
                src="/images/minelab-rttr/minelabs-logo.png"
                alt="Minelab"
                className="ml-rttr-loading-logo"
            />
            <div className="ml-rttr-loading-dots">
                <span className="ml-rttr-loading-dot" />
                <span className="ml-rttr-loading-dot" />
                <span className="ml-rttr-loading-dot" />
            </div>
        </div>
    );
};

export default MinelabRttrLoadingFallback;
